{
  "iframeWaitingMessage": "Obrigado por aguardar. Só mais um momento...",
  "solutionIframe": "Conteúdo principal",
  "unloadPromptMessage": "Tem certeza?"
}
